import { render, staticRenderFns } from "./contest-introduce.vue?vue&type=template&id=0e831a52&scoped=true"
import script from "./contest-introduce.vue?vue&type=script&lang=js"
export * from "./contest-introduce.vue?vue&type=script&lang=js"
import style0 from "./contest-introduce.vue?vue&type=style&index=0&id=0e831a52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e831a52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e831a52')) {
      api.createRecord('0e831a52', component.options)
    } else {
      api.reload('0e831a52', component.options)
    }
    module.hot.accept("./contest-introduce.vue?vue&type=template&id=0e831a52&scoped=true", function () {
      api.rerender('0e831a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/detail-pane/contest-introduce.vue"
export default component.exports